import _ from "lodash";
import { observable, computed, action, observe } from "mobx";
import { asyncAction } from "mobx-utils";
import Autobind from "autobind-decorator";
import SarcopeniaRepository from "pages/demo-dashboard/modules/repository/SarcopeniaRepository";
import SarcopeniaMeasureModel from "pages/demo-dashboard/modules/model/sarcopeniaMeasureModel";
import { getToolState, addToolState } from "component/toolManager/toolState.js";
import BaseBrushTool from "component/molecules/viewport/tools/annotation/base/BaseBrushTool";
import CustomEvent from "core/customEvent";
import { getEnabledElements } from "component/toolManager/enabledElements.js";
import RootStore from "./rootStore";

// import { reaction, makeAutoObservable } from "mobx";
import { reaction, IReactionPublic } from "mobx";
import brushModule from "component/molecules/viewport/tools/annotation/brushTool/brushModule";

function roundHistogram(arr: number[]) {
  return arr.map((v) => parseFloat(v.toFixed(2)));
}
/**
 * @class WorklistStore
 * @description 요청에 따른 Study 목록을 반환
 */
@Autobind
class SarcopeniaMeasureStore {
  _rootStore: RootStore; /// rootStore 객체. 다른 Store를 연계할 때 사용
  @observable opacity = 0.8;

  @observable mode: 'view' | 'edit' = 'view';
  @computed get isEditMode() {
    return this.mode === 'edit';
  }

  @action.bound
  setMode(newMode: 'view' | 'edit') {
    this.mode = newMode;
  }
  @observable _measureDatalist = [];
  handleModeChanged(newMode: 'view' | 'edit', prevMode: 'view' | 'edit') {
  }

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;

    // ✅ reaction은 이 버전에서도 사용 가능
    let prevMode: 'view' | 'edit' = this.mode;

    reaction(
      () => this.mode,
      (newMode, _reaction) => {
        if (prevMode !== newMode) {
          if (newMode == 'view')
          {
            this.changeMaskInfer2Total(newMode);
          }
          else
          {
            this.changeMaskTotal2infer(newMode);
          }
          prevMode = newMode; // 이전값 갱신
        }
      }
    );

  }

  // _measureDatalist = [];

  _isProcessing = false;


  @observable
  _visibleMap_5Cls: { [key: string]: boolean } = {
    SMA: true,
    NAMA: true,
    LAMA: true,
    IMAT: true,
    SFat: true,
    VFat: true,
  };

  @observable
  _visibleMap_3Cls: { [key: string]: boolean } = {
    SFAT: true,
    SMA: true,
    VFAT: true,
  };
  
  @action.bound
  toggleVisibility(name: string) {
    if (this.mode === 'view')
    {
      this._visibleMap_5Cls[name] = !this._visibleMap_5Cls[name]
    }
    else
    {
      Object.keys(this._visibleMap_3Cls).forEach(key => {
        this._visibleMap_3Cls[key] = (key === name);
      });
    }
    this.updateMaskWithVisibility(); // ✅ 마스크 업데이트 트리거
    
  }

  get isVisible() {
    if (this.mode === 'view')
    {
      return (name: string) => this._visibleMap_5Cls[name] || true;
    }
    else
    {
      return (name: string) => this._visibleMap_3Cls[name] || true;
    }
}

  @action
  clear() {
    this._measureDatalist = [];
  }

  changeMaskInfer2Total(mode: any){

    const colorSet = [
      [0, 0, 0, 0], // background
      [110, 29, 20, 127], // sfat
      [67, 38, 126, 127], // vfat
      [230, 225, 0, 255], // IMA
      [2, 211, 216, 255], // LAMA
      [184, 1, 5, 255], // NAMA
      [105, 91, 135, 127]
    ]
    brushModule.setters.useColorSet(colorSet);
    brushModule.setters.useColorSetAlpha((this.opacity / 100.0) * 255.0);


    // 모드 전환 시 모두 True로 설정
    Object.keys(this._visibleMap_5Cls).forEach(key => {
      this._visibleMap_5Cls[key] = true;
    });

    let totalEnabledElement = getEnabledElements();
    let mainEnabledElement = totalEnabledElement[0];
    let toolState = getToolState(
      mainEnabledElement.element,
      BaseBrushTool.getReferencedToolDataName()
    );

    const toolData = toolState.data;
    toolData[0].pixelData = this._measureDatalist[0]["mask"];
    toolData[0].originalPixelData = this._measureDatalist[0]["mask"];
    toolData[0].invalidated = true;
    toolData[0].mode = false;
  
    CustomEvent.triggerEvent(
      mainEnabledElement.element,
      CustomEvent.EVENTS.IMAGE_RENDERED,
      mainEnabledElement
    );

    toolData[0].invalidated = false;
  }


  changeMaskTotal2infer(mode: any){
    const colorSet = [
      [0, 0, 0, 0], // background
      [110, 29, 20, 127],
      [2, 211, 216, 127], // sfat
      [230, 225, 0, 127], // vfat
      [230, 225, 0, 127], // IMA
      [110, 29, 20, 127], // LAMA
      [184, 1, 5, 127], // NAMA
    ]
    // 모드 전환 시 모두 True로 설정
    Object.keys(this._visibleMap_3Cls).forEach(key => {
      this._visibleMap_3Cls[key] = false;
    });
    
    let totalEnabledElement = getEnabledElements();
    let mainEnabledElement = totalEnabledElement[0];
    let toolState = getToolState(
      mainEnabledElement.element,
      BaseBrushTool.getReferencedToolDataName()
    );

    const toolData = toolState.data;
    toolData[0].pixelData = this._measureDatalist[0]["infer_mask"];
    toolData[0].originalPixelData = this._measureDatalist[0]["infer_mask"];
    toolData[0].invalidated = true;
    toolData[0].mode = true;

    brushModule.setters.useColorSet(colorSet);
    
    brushModule.setters.useColorSetAlpha((this.opacity / 100.0) * 255.0);
  
    CustomEvent.triggerEvent(
      mainEnabledElement.element,
      CustomEvent.EVENTS.IMAGE_RENDERED,
      mainEnabledElement
    );

    toolData[0].invalidated = false;
  }



  /////////////////////////////////////////////
  applyMaskFromUndoStack() {
    let totalEnabledElement = getEnabledElements();
    let mainEnabledElement = totalEnabledElement[0];
    let toolState = getToolState(
      mainEnabledElement.element,
      BaseBrushTool.getReferencedToolDataName()
    );
    const toolData = toolState.data;

    if (!toolData || !toolData[0] || !toolData[0].originalPixelData) {
      return;
    };
    
    const undoStack = toolData[0].undoStack;
  
    if (!undoStack || undoStack.length === 0) {
      return
    };
    
    const prev = undoStack.pop();
    if (!prev) return;
    
    // Apply to both original + pixelData
    toolData[0].pixelData = prev;
    toolData[0].invalidated = true;
  
    CustomEvent.triggerEvent(
      mainEnabledElement.element,
      CustomEvent.EVENTS.IMAGE_RENDERED,
      mainEnabledElement
    );

    toolData[0].invalidated = false;
  }

  
  @action
  getMeasureArea() {
    let measureArea: any = [];
    this._measureDatalist.map((measureData) => {
      const area: { [key: string]: any } = measureData["Area"] || {};

      const round2 = (val: any) =>
        typeof val === "number" ? val.toFixed(2) : null;

      measureArea.push({
        IMAT: _.has(area, "IMA_Area") ? round2(area["IMA_Area"]) : null,
        LAMA: _.has(area, "LAMA_Area") ? round2(area["LAMA_Area"]) : null,
        NAMA: _.has(area, "NAMA_Area") ? round2(area["NAMA_Area"]) : null,
        SFat: _.has(area, "SFAT_Area") ? round2(area["SFAT_Area"]) : null,
        VFat: _.has(area, "VFAT_Area") ? round2(area["VFAT_Area"]) : null,
        SMA: _.has(area, "SMA_Area") ? round2(area["SMA_Area"]) : null,
      });
    });

    if (measureArea.length > 0) {
      return measureArea[0];
    }

    return [];
  }

  // @action
  // getMeasureArea() {
  //   let measureArea: any = [];
  //   this._measureDatalist.map((measureData) => {
  //     measureArea.push({
  //       IMAT:
  //         _.has(measureData, "Area.IMA_Area") &&
  //         measureData["Area"]["IMA_Area"],
  //       LAMA:
  //         _.has(measureData, "Area.LAMA_Area") &&
  //         measureData["Area"]["LAMA_Area"],
  //       NAMA:
  //         _.has(measureData, "Area.NAMA_Area") &&
  //         measureData["Area"]["NAMA_Area"],
  //       SFat:
  //         _.has(measureData, "Area.SFAT_Area") &&
  //         measureData["Area"]["SFAT_Area"],
  //       VFat:
  //         _.has(measureData, "Area.VFAT_Area") &&
  //         measureData["Area"]["VFAT_Area"],
  //       SMA:
  //         _.has(measureData, "Area.SMA_Area") &&
  //         measureData["Area"]["SMA_Area"],          
  //     });
  //   });

  //   if (measureArea.length > 0) {
  //     return measureArea[0];
  //   }

  //   return [];
  // }

  getHistograms() {
    let histograms: any = [];
    this._measureDatalist.map((measureData) => {
      histograms.push({
        IMA:
          _.has(measureData, "Histogram.IMA_Histogram") &&
          measureData["Histogram"]["IMA_Histogram"],
        LAMA:
          _.has(measureData, "Histogram.LAMA_Histogram") &&
          measureData["Histogram"]["LAMA_Histogram"],
        NAMA:
          _.has(measureData, "Histogram.NAMA_Histogram") &&
          measureData["Histogram"]["NAMA_Histogram"],
        SFat:
          _.has(measureData, "Histogram.SFAT_Histogram") &&
          measureData["Histogram"]["SFAT_Histogram"],
        VFat:
          _.has(measureData, "Histogram.VFAT_Histogram") &&
          measureData["Histogram"]["VFAT_Histogram"],
        SMA:
          _.has(measureData, "Histogram.SMA_Histogram") &&
          measureData["Histogram"]["SMA_Histogram"],                 
      });
    });

    if (histograms.length > 0) {
      return histograms[0];
    }

    return [];
  }
  
  getCheckedColorCount() {
    if (this.mode === 'view')
    {
      const keys = ["SFat", "VFat", "IMAT", "LAMA", "NAMA"];
      return keys.filter(key => this._visibleMap_5Cls[key]).length;
    }
    else
    {
      const keys = ["SFAT", "SMA", "VFAT"];
      return keys.filter(key => this._visibleMap_3Cls[key]).length;
    }
  }

  @action
  findAllMeasurements() {
    let allMeasurement: any = [];

    this._measureDatalist.map((measureData) => {
      let measurement: any = {};
      // for (var key in measureData["detail"]) {
      //   measurement[key] = measureData["detail"][key];
      // }

      for (var key in measureData["Area"]) {
        measurement[key] = measureData["Area"][key];
      }
      // allMeasurement.push(measurement);

      for (var key in measureData["detail"]) {
        measurement[key] = measureData["detail"][key];
      }
      allMeasurement.push(measurement);
    });

    if (allMeasurement.length == 0) {
      return [];
    }

    return allMeasurement;
  }

  /**
   * @function findAllStudy
   * @description Repository 로 부터 획득한 study 목록 반환
   */
  @asyncAction
  async *requestMeasureSarcopenia(
    pixelData: any,
    mask: any,
    editmode: any,
    mask_status: any,
    width: any,
    height: any,
    pixelSpacingX: any,
    pixelSpacingY: any,
    sliceThickness: any,
    token: any
  ) {
    //async *findAllStudy(queryAttributes?: [string]) {
    /// 서버로부터 study 목록에 대한 정보를 요청/수신한다.
    if (this._isProcessing === true) {
      return false;
    }
    this._isProcessing = true;

    const {
      data,
      status,
    } = yield SarcopeniaRepository.requestMeasureSarcopenia(
      pixelData,
      mask,
      editmode,
      mask_status,
      width,
      height,
      pixelSpacingX,
      pixelSpacingY,
      sliceThickness,
      token
    );

    
    if (status === 402) { // 🔥 크레딧 부족 상태 처리 추가
      this._isProcessing = false;
      throw {
        message: data.error,
        redirect_url: data.redirect_url
      };
    }
    else if(status !== 200){
      this._isProcessing = false;
      throw {
        message: data.error,
      };
    }
  
    /// 데이터를 성공적으로 수신하였을 경우, worklist 변수에 수신한 study 목록을 저장한다.
    if (status === 200) {
      //추론 완료 시 this._visibleMap 모두 true
      Object.keys(this._visibleMap_5Cls).forEach(key => {
        this._visibleMap_5Cls[key] = true;
      });

      let totalEnabledElement = getEnabledElements();
      let mainEnabledElement = totalEnabledElement[0];
      let toolState = getToolState(
        mainEnabledElement.element,
        BaseBrushTool.getReferencedToolDataName()
      );
    
      const toolData = toolState.data;
      const newMask = new Uint8Array(data[0].mask); // 🔹 새 마스크 데이터 (갱신할 부분)
      const oldMask = toolData[0].pixelData;        // 기존 마스크 데이터
    
      // 🔧 기존 마스크 유지하면서 새 마스크 값이 0이 아닌 부분만 덮어쓰기
      for (let i = 0; i < newMask.length; i++) {
        if (newMask[i] !== 0) {
          oldMask[i] = newMask[i];
        }
      }
    
      toolData[0].originalPixelData = oldMask.slice(); // ✅ 덮어쓴 후 원본 저장
      toolData[0].invalidated = true;
      toolData[0].undoStack = [];

      if(this.mode === 'edit')
      {
        this.setMode("view")
      }
  
      CustomEvent.triggerEvent(
        mainEnabledElement.element,
        CustomEvent.EVENTS.IMAGE_RENDERED,
        mainEnabledElement
      );
      
      this._measureDatalist = data.map(
        (measureData: {}) => new SarcopeniaMeasureModel(measureData)
      );
    
      this._rootStore.panelControlStore.setAllPanelDisableState(false);
    }
    
    this._isProcessing = false;
    return true;
  }

  @action
  cancelRequestMeasureSarcopenia() {
    return SarcopeniaRepository.cancelRequestMeasureSarcopenia();
  }

  @action
  updateMaskWithVisibility() {
    // console.log("[AFTER]_measureDatalist.length: ", this._measureDatalist.length);
    // console.log("[AFTER]_measureDatalist: ", this._measureDatalist);
    let totalEnabledElement = getEnabledElements();
    let mainEnabledElement = totalEnabledElement[0];
    let toolState = getToolState(
      mainEnabledElement.element,
      BaseBrushTool.getReferencedToolDataName()
    );


    const toolData = toolState.data;

    if (!toolData || !toolData[0] || !toolData[0].originalPixelData) return;

    const originalMask = toolData[0].originalPixelData.slice();

    let visibleMap;
    let classLabelMap: { [key: string]: number };
    if (this.mode === 'view')
    {
      visibleMap = this._visibleMap_5Cls;
      classLabelMap = {
        SFat: 1,
        VFat: 2,
        IMAT: 3,
        LAMA: 4,
        NAMA: 5,
      };
    }
    else
    {
      visibleMap = this._visibleMap_3Cls;
      classLabelMap = {
        SFAT: 1,
        SMA: 2,
        VFAT: 3,
      };
    }
    
    const indexToClassName: { [key: number]: string } = {};
    for (const [k, v] of Object.entries(classLabelMap)) {
      indexToClassName[v] = k;
    }

    const filteredMask = new Uint8Array(originalMask.length);
    for (let i = 0; i < originalMask.length; i++) {
      const label = originalMask[i];
      if (label === 0) {
        filteredMask[i] = 0;
        continue;
      }
      const className = indexToClassName[label];
      // filteredMask[i] = visibleMap[className] ? label : 0;
      if (this.mode == 'view')
      {
        filteredMask[i] = visibleMap[className] ? label : 0;
      }
      else
      {
        filteredMask[i] = label;
      }
    }

    toolData[0].pixelData = filteredMask;
    toolData[0].invalidated = true;

    // undo 생성
    const colorCount = this.getCheckedColorCount();
    toolData[0].colorCount = colorCount;
    if (this.mode === 'edit' && colorCount === 1)
    {
      const keys = ["SFAT", "SMA", "VFAT"];
      const selected_cls = keys.filter(key => this._visibleMap_3Cls[key]);
      toolData[0].color = classLabelMap[selected_cls[0]];

      const backup = toolData[0].pixelData.slice();
      toolData[0].undoStack.push(backup);
      toolData[0].undoStack.push(backup);
      toolData[0].undoStack.push(backup);
      toolData[0].undoStack.push(backup);
      toolData[0].undoStack.push(backup);
     
    }
    // toolData[0].color = 2;
    // const backup = toolData[0].pixelData.slice();
    // toolData[0].undoStack.push(backup);
    
    CustomEvent.triggerEvent(
      mainEnabledElement.element,
      CustomEvent.EVENTS.IMAGE_RENDERED,
      mainEnabledElement
    );
  }

}


export default SarcopeniaMeasureStore;
